import { useLocationParams } from "@/providers/BCRoutingContextProvider";
import { useEffect, useState } from "react";

const getStacklineSkuFromVariantId = (
  variantId: string | undefined | null
): string | undefined => {
  if (!variantId) {
    return (window as any).bcProductMetaData?.stacklineSku;
  }
  return (
    (window as any).bcProductMetaData?.variations[variantId]?.stacklineSku ??
    undefined
  );
};
export const useCurrentStacklineSku = (): string | undefined => {
  const searchParams = useLocationParams();
  const variantId = searchParams?.get("variant");
  const [stacklineSku, setStacklineSku] = useState(
    getStacklineSkuFromVariantId(variantId)
  );

  useEffect(() => {
    setStacklineSku(getStacklineSkuFromVariantId(variantId));
  }, [variantId]);

  return stacklineSku;
};
